import { type UniquePageProps } from "../index";
import { HowCreateAutoOrderModel } from "@admin/domain/uniquePages/models/HowCreateAutoOrderModel";
import HowCreateAutoOrderActionBlocks from "./HowCreateAutoOrderActionBlocks";
import React from "react";

export default function HowCreateAutoOrderPage({ page }: UniquePageProps<HowCreateAutoOrderModel>) {
    return (
        <div>
            <h2 className="mb-5">Контент страницы "Как оформить Автозаказ в интернет-магазине Tentorium.ru"</h2>
            <HowCreateAutoOrderActionBlocks initActionBLocks={page.contentObject.action_blocks} />
        </div>
    );
}
